import type { LeadForm, LeadLocale } from "./contact-lead";

export type SubmitLeadResult = "accepted" | "rate_limited" | "failed";
export type LeadFetch = (
  input: RequestInfo | URL,
  init?: RequestInit,
) => Promise<Response>;

export async function submitLead(
  values: LeadForm,
  locale: LeadLocale,
  website: string,
  idempotencyKey: string,
  fetcher: LeadFetch = fetch,
): Promise<SubmitLeadResult> {
  try {
    const response = await fetcher("/api/leads", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "idempotency-key": idempotencyKey,
      },
      body: JSON.stringify({ ...values, locale, website }),
    });
    if (response.ok) return "accepted";
    return response.status === 429 ? "rate_limited" : "failed";
  } catch {
    return "failed";
  }
}
